import type {Filter} from '@smart/analytics';
import type {Facet} from '../components/facet-panel';

export const filterSelectedOptions = (data: Facet[]) =>
  data
    .flatMap((item) => {
      return item.options.filter((option) => option.selected);
    })
    .map(
      (option) =>
        ({
          id: `${option.facetId}.${option.id}`,
          name: option.facetId,
          value: option.displayName,
        } as unknown as Filter),
    );
